/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDownload = createReactComponent("download", "IconDownload", [
  ["path", { d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2", key: "svg-0" }],
  ["path", { d: "M7 11l5 5l5 -5", key: "svg-1" }],
  ["path", { d: "M12 4l0 12", key: "svg-2" }]
]);

export { IconDownload as default };
//# sourceMappingURL=IconDownload.js.map
